module.exports = __webpack_public_path__ + "static/img/4.9e3461d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc/4.png
// module id = yUw6
// module chunks = 0